/** The products this app serves, each from its own domains. */
export enum Product {
  Insure = 'insure',
  Bookkeeper = 'bookkeeper',
  CaiAgent = 'cai_agent',
}
